module.exports = __webpack_public_path__ + "static/xvart-91b1f63dbbef05b1dd47114bf3ae39e8.jpeg";